<ul class="course-exercise-competences d-flex align-items-center flex-wrap">
  <li class="competence-badge" *ngFor="let competence of competences">
    <badge icon="puzzle">
      {{competence.name}} <span class="competence-points">({{competence.points}} pt)</span>
    </badge>
  </li>
</ul>